var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.homeData)?_c('v-container',[(_vm.isTeacher)?_c('teacher',{attrs:{"loading":_vm.loading},on:{"load":_vm.loadData}}):_c('student',{attrs:{"loading":_vm.loading},on:{"load":_vm.loadData}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }